/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { Popover } from 'bootstrap'

import { disposeTooltip } from '@/js/utils/bootstrap'
/**
 * Activate a Bootstrap popover on each popover-toggle element. Disposes it on
 * disconnect.
 *
 * @type {Listener}
 */
export default {
    selector: '[data-bs-toggle="popover"]',
    connect(element) {
        Popover.getOrCreateInstance(element)

        return () => disposeTooltip(Popover.getInstance(element))
    },
}
